<script lang="ts">
  import { ReviewType } from '$provider/constants/ReviewType';
  import Button from '$shared/atoms/Button/Button.svelte';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    name?: string;
    title?: string;
    type?: ReviewType;
    style?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { name = '', title = '', type = ReviewType.None, style = '', onclick }: Props = $props();
</script>

<div data-cy={`${name}-title`} class="title">
  {#if title}
    <Button name={`${name}-provider-btn`} style={style || ButtonStyle.NoLink} {onclick}>
      {title || 'Unknown Title'}
    </Button>
    {#if type}
      <div class="type">{type}</div>
    {/if}
  {/if}
</div>

<style>
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }
  .title .type:before {
    content: '/';
    margin-right: 8px;
  }
</style>
